import React, { useState } from 'react'
import { Toggle } from 'ui-kit/toggle'

import { FAQContainer, FAQContent, FAQHeader, FAQItem, FAQText, FAQTitle } from './faqs.styles'

export interface FAQItem {
  question: string
  answer: string
}

interface FAQsProps {
  items: FAQItem[]
}

export const FAQs: React.FC<FAQsProps> = ({ items }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const toggleItem = (index: number) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index))
  }

  return (
    <FAQContainer>
      <h2 style={{ marginBottom: '1rem' }}>Frequently Asked Questions</h2>
      {items.map((item, index) => (
        <FAQItem key={index}>
          <FAQHeader onClick={() => toggleItem(index)}>
            <FAQTitle>{item.question}</FAQTitle>
            <Toggle isOn={openIndex === index} />
          </FAQHeader>
          <FAQContent isOpen={openIndex === index}>
            <FAQText>{item.answer}</FAQText>
          </FAQContent>
        </FAQItem>
      ))}
    </FAQContainer>
  )
}
